<template>
  <v-container fluid class="mt-0 pt-0">
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="deleteDialog" max-width="600px">
      <v-card v-if="selected">
        <v-card-title primary-title>
          Confirm Delete Records
        </v-card-title>
        <v-card-text>
          Click on the confirm button below to remove the
          <strong
            >{{
              selected
                .map((s) => s.punchTimeline.map((pt) => pt.punchDocId))
                .flat().length
            }}
            punch record(s)</strong
          >
          permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            @click="deleteRows"
            :loading="bulkChangeLoading"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogJobChange" max-width="600px">
      <v-card v-if="selected">
        <v-card-title primary-title>
          Job Site Change
        </v-card-title>
        <v-card-text>
          Select the new job site and click on the confirm button below to
          change the job site for
          {{ selected.length }} record(s).
          <br />
          <job-selector
            @jobSiteChange="newJobSite = $event"
            ref="dialogJobSelectorRef"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="
              dialogJobChange = false;
              $refs.dialogJobSelectorRef.clearJobSite();
            "
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            @click="jobChangeRows"
            :loading="bulkChangeLoading"
            :disabled="!newJobSite"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPunchDirectionChange" max-width="600px">
      <v-card v-if="selected">
        <v-card-title primary-title>
          Punch Direction Change
        </v-card-title>
        <v-card-text>
          Update the selected {{ selected.length }} record(s) from a punch
          {{ this.filter.punchDirection }} to a punch
          {{ this.oppositePunchDirection }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogPunchDirectionChange = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            @click="punchDirectionChangeRows"
            :loading="bulkChangeLoading"
            :disabled="bulkChangeLoading"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPunchTimeChange" max-width="600px">
      <v-card v-if="selected">
        <v-card-title primary-title>
          Punch Time Change
        </v-card-title>
        <v-card-text>
          Select a new in and/or out time and click on the confirm button below
          to change the time for
          {{
            selected
              .map((s) => s.punchTimeline.map((pt) => pt.punchDocId))
              .flat().length
          }}
          punch record(s).
          <br />
          <br />
          <v-text-field
            label="New Punch In Time"
            v-model="newPunchInTime"
            type="time"
            style="font-size:12px;min-height:40px"
            color="primary"
            outlined
            class="tool-run-time"
            prepend-icon="mdi-clock"
            hint="Only updates the time of punch in records."
            persistent-hint
          ></v-text-field>
          <br />
          <v-text-field
            label="New Punch Out Time"
            v-model="newPunchOutTime"
            type="time"
            style="font-size:12px;min-height:40px"
            color="primary"
            outlined
            class="tool-run-time"
            prepend-icon="mdi-clock"
            hint="Only updates the time of punch out records."
            persistent-hint
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogPunchTimeChange = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            @click="punchTimeChangeRows"
            :loading="bulkChangeLoading"
            :disabled="
              bulkChangeLoading || (!newPunchInTime && !newPunchOutTime)
            "
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <h1 class="headline">
          Payroll
          <v-btn
            color="primary"
            small
            @click="toggleDialogAddPunch"
            class="mr-2 ml-4"
          >
            <v-icon small left>add</v-icon>Add Punch
          </v-btn>
          <v-btn small color="primary" @click="getCsv" class="mr-2">
            <v-icon left>download</v-icon>Export Report
          </v-btn>
          <v-btn
            small
            color="primary"
            @click="dialogLeaderboard = true"
            v-if="!forceJobSiteId"
          >
            <v-icon left>trending_up</v-icon>Leaderboard
          </v-btn>
          <v-btn
            small
            color="primary"
            @click="dialogLocationStats = true"
            v-if="!forceJobSiteId"
            class="ml-2"
          >
            <v-icon left>location_on</v-icon>Location Stats
          </v-btn>
          <v-dialog v-model="dialogAddPunch" persistent max-width="490">
            <v-card>
              <v-card-title class="text-h5">
                Add Punch
              </v-card-title>
              <v-card-text
                >Please fill out the form to create a new punch.</v-card-text
              >
              <v-form ref="form" style="padding:0 24px;">
                <v-radio-group v-model="dialogAddPunchRecord.direction">
                  <v-radio :key="1" label="Punch In" value="in"></v-radio>
                  <v-radio :key="2" label="Punch Out" value="out"></v-radio>
                </v-radio-group>
                <v-autocomplete
                  placeholder="Employee Search"
                  :items="allEmployees"
                  item-text="name"
                  item-value="docId"
                  v-model="dialogAddPunchRecord.employeeDocIds"
                  prepend-icon="person"
                  hide-details
                  multiple
                >
                </v-autocomplete>
                <br />
                <job-selector
                  v-if="!forceJobSiteId"
                  @jobSiteChange="dialogAddPunchRecord.jobSite = $event"
                  ref="dialogJobSelectorRef"
                />
                <v-menu
                  v-model="addPunchRecordMenu"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dialogAddPunchRecord.date"
                      label="Punch Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dialogAddPunchRecord.date"
                    @input="addPunchRecordMenu = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                  label="Punch Time"
                  v-model="dialogAddPunchRecord.time"
                  type="time"
                  style="font-size:12px;min-height:40px"
                  color="primary"
                  outlined
                  class="tool-run-time"
                  prepend-icon="mdi-clock"
                ></v-text-field>
                <br />
              </v-form>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="
                    dialogAddPunch = false;
                    $refs.dialogJobSelectorRef.clearJobSite();
                  "
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  @click="addPunch"
                  :loading="dialogAddPunchLoading"
                  :disabled="dialogAddPunchLoading"
                >
                  Add Punch
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </h1>
      </v-col>
      <v-col cols="12" sm="12" md="3" class="py-0">
        <v-menu
          ref="dialogDatePicker"
          v-model="dialogDatePicker"
          :close-on-content-click="false"
          :return-value.sync="filter.dates"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="Date Range"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker v-model="filter.dates" range>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogDatePicker = false">
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $refs.dialogDatePicker.save(filter.dates);
                getTable();
              "
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="12" md="4" class="py-0" v-if="!forceJobSiteId">
        <job-selector @jobSiteChange="updateFilterJobSite($event)" />
      </v-col>
      <v-col cols="12" sm="12" md="3" class="py-0">
        <v-select
          clearable
          multiple
          v-model="filter.department"
          :items="activeDepartments"
          label="Department Code"
          prepend-icon="badge"
          @change="updateFilterDepartment"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="2" class="py-0">
        <v-autocomplete
          clearable
          auto-select-first
          v-model="filter.punchedInBy"
          :items="activePunchedInBy"
          label="Punched In By"
          prepend-icon="account_box"
          no-data-text="No matching name"
          @change="updateFilterPunchedInBy"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="12" md="2" class="py-0">
        <v-select
          v-model="filter.punchDirection"
          :items="['in & out', 'in', 'out']"
          label="Punch Direction"
          prepend-icon="transfer_within_a_station"
          @change="updateFilterPunchDirection"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="3" class="py-0">
        <v-select
          clearable
          v-model="filter.locationStatus"
          :items="activelocationStatus"
          label="Punch Location"
          prepend-icon="location_on"
          @change="updateFilterLocationStatus"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="3" class="py-0 d-flex align-center">
        <v-switch
          v-model="filter.includeTerminated"
          label="Include terminated employees"
          prepend-icon="person_off"
          class="mt-0"
          hide-details
          @change="updateFilterIncludeTerminated"
        ></v-switch>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-alert
          text
          dense
          color="red"
          icon="mdi-clock-fast"
          border="left"
          v-if="punchErrorCount > 0"
        >
          {{ this.punchErrorCount }} records below have errors that need
          resolution.
        </v-alert>
        <v-alert
          dense
          color="grey lighten-5"
          icon="library_add_check"
          border="left"
          v-if="selected.length"
        >
          {{ this.selected.length }} row(s) selected. &nbsp;&nbsp;
          <v-btn outlined text small lass="ml-4" @click="deleteDialog = true"
            ><v-icon small class="mr-2" color="primary">delete_forever</v-icon>
            delete</v-btn
          >
          <v-btn
            outlined
            text
            small
            class="ml-4"
            @click="dialogJobChange = true"
            v-if="!forceJobSiteId"
            ><v-icon small class="mr-2" color="primary">work</v-icon> change
            jobsite</v-btn
          >
          <v-btn
            outlined
            text
            small
            class="ml-4"
            @click="dialogPunchDirectionChange = true"
            :disabled="!oppositePunchDirection"
            ><v-icon small class="mr-2" color="primary"
              >transfer_within_a_station</v-icon
            >
            change direction</v-btn
          >
          <v-btn
            outlined
            text
            small
            class="ml-4"
            @click="dialogPunchTimeChange = true"
            ><v-icon small class="mr-2" color="primary">mdi-clock</v-icon>
            change time</v-btn
          >
        </v-alert>
        <v-data-table
          :headers="tableHeaders"
          :items="table"
          class="elevation-1"
          :loading="loading"
          :search="search"
          :custom-filter="filterByName"
          item-key="key"
          v-model="selected"
          show-select
          :items-per-page="25"
          :page.sync="page"
          :footer-props="{
            itemsPerPageOptions: [25, 50, 100, -1],
          }"
          dense
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              outlined
              label="Filter by first name or last name or ID"
              dense
              class="mx-4 pt-4 mb-2"
              hide-details
            ></v-text-field>
          </template>
          <template v-slot:item.employee="{ item }">
            {{ item.employee.name }}
          </template>
          <template v-slot:item.hours="{ item }">
            {{ item.hours }}
            <v-tooltip top v-if="item.hoursDeducted > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-icon left small v-on="on" class="primary--text"
                  >calculate</v-icon
                >
              </template>
              <span>{{ item.hoursDeducted }} hour(s) deducted</span>
            </v-tooltip>
          </template>
          <template v-slot:item.selfie="{ item }">
            <ul class="mt-1">
              <li
                v-for="p in item.punchTimeline"
                :key="p.time.seconds"
                style="list-style-type: none;font-size: 0;"
              >
                <SelfieThumbnail
                  v-if="p.selfie"
                  :punchDocId="p.punchDocId"
                  class="mb-1"
                />
              </li>
            </ul>
          </template>
          <template v-slot:item.punchTimeline="{ item }">
            <ul>
              <li v-for="p in item.punchTimeline" :key="p.time.seconds">
                <span
                  class="caption"
                  style="display:inline-block;width:35px;text-transform:uppercase"
                  >{{ p.direction }}:</span
                >
                <v-tooltip top v-if="p.source == 'camera'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-on="on" class="primary--text mr-0 mb-1"
                      >photo_camera</v-icon
                    >
                  </template>
                  <span
                    >Camera by {{ (p.createdBy || {}).firstName }}
                    {{ (p.createdBy || {}).lastName }}</span
                  >
                </v-tooltip>
                <v-tooltip top v-if="p.source == 'manual'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-on="on" class="red--text mr-0 mb-1"
                      >keyboard</v-icon
                    >
                  </template>
                  <span
                    >Manual by {{ (p.createdBy || {}).firstName }}
                    {{ (p.createdBy || {}).lastName }}</span
                  >
                </v-tooltip>
                <v-tooltip top v-if="p.source == 'employee-app'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-on="on" class="primary--text mr-0 mb-1"
                      >smartphone</v-icon
                    >
                  </template>
                  <span
                    >Employee App by {{ (p.createdBy || {}).firstName }}
                    {{ (p.createdBy || {}).lastName }}</span
                  >
                </v-tooltip>
                <PunchLocation
                  v-if="p.geolocationData"
                  :geolocation="p.geolocationData"
                  :jobSiteLocation="getJobSiteLocation(item.jobSite)"
                  :distanceMeters="p.distanceMeters"
                  :locationType="p.locationType"
                />
                {{ p.time.toDate() | moment("MMM Do [at] h:mma") }}
                <v-tooltip top v-if="p.hasPendingDispute">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon left small v-on="on" v-bind="attrs" class="red--text"
                      >gavel</v-icon
                    >
                  </template>
                  <span>This punch has a pending dispute.</span>
                </v-tooltip>
                <v-tooltip top v-if="p.editedBy">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon left small v-on="on" class="orange--text"
                      >auto_fix_high</v-icon
                    >
                  </template>
                  <span
                    >Edited by {{ p.editedBy.firstName }}
                    {{ p.editedBy.lastName }}</span
                  >
                </v-tooltip>
                <v-tooltip
                  v-if="p.direction === 'out' && p.lunches && (Array.isArray(p.lunches) ? p.lunches.some(l => l.notes && (!l.approvalStatus || l.approvalStatus === 'pending')) : Object.values(p.lunches).some(l => l && l.notes && (!l.approvalStatus || l.approvalStatus === 'pending')))"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      x-small
                      class="ml-1 orange--text"
                      v-on="on"
                      v-bind="attrs"
                    >
                      no_meals
                    </v-icon>
                  </template>
                  <span>
                    <strong>No lunch claim(s) - Pending Review</strong><br />
                    <template v-for="(lunch, idx) in (Array.isArray(p.lunches) ? p.lunches : Object.values(p.lunches))">
                      <div v-if="lunch && lunch.notes && (!lunch.approvalStatus || lunch.approvalStatus === 'pending')" :key="idx" style="margin-top: 4px;">
                        <strong>Lunch {{ idx + 1 }}:</strong> {{ lunch.notes || 'No reason provided' }}
                      </div>
                    </template>
                  </span>
                </v-tooltip>
              </li>
            </ul>
          </template>
          <template v-slot:item.edit="{ item }">
            <div class="d-flex align-center">
              <v-btn
                text
                outlined
                x-small
                @click="showEditPunchDialog(item)"
                class="mr-1"
              >
                EDIT
              </v-btn>
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on">
                    <v-icon small>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="viewEmployee(item.employee)">
                    <v-list-item-icon>
                      <v-icon>person</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>View Employee</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="showEmployeeNoteDialog(item)">
                    <v-list-item-icon>
                      <v-icon>note_add</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Add Note</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="showEmployeeNotesListDialog(item.employee)"
                  >
                    <v-list-item-icon>
                      <v-icon>list_alt</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>View Notes</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
          <template v-slot:item.ns="{ item }">
            <v-tooltip top v-if="item.ns">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" small class="red--text">event</v-icon>
              </template>
              <span>No Schedule</span>
            </v-tooltip>
          </template>
          <template v-slot:item.createdBy="{ item }">
            <a :href="item.createdByMailto">{{ item.createdBy }}</a>
          </template>
          <template v-slot:item.error="{ item }">
            <v-tooltip top v-if="item.error">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" small class="red--text"
                  >transfer_within_a_station</v-icon
                >
              </template>
              <span>{{ item.error }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.early="{ item }">
            <span>{{ item.early }}</span>
          </template>
          <template v-slot:item.late="{ item }">
            <span>{{ item.late }}</span>
            <v-tooltip v-if="item.lateClockOutReason" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small class="ml-1">mdi-message-text-outline</v-icon>
              </template>
              <span>{{ item.lateClockOutReason }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-dialog v-model="dialogEditPunch" persistent max-width="490">
          <v-card>
            <v-card-title class="text-h5">
              Edit Punch
            </v-card-title>
            <v-card-text>
              Provide a new punch time or mark a punch for deletion.
              <br />
              <br />
              <span v-if="dialogEditPunchRecord.employee"
                >{{ dialogEditPunchRecord.employee.firstName }}
                {{ dialogEditPunchRecord.employee.lastName }}</span
              >
              <br />Barcode ID: {{ dialogEditPunchRecord.barcodeId }}
              <br />Code:
              {{ dialogEditPunchRecord.code }}
              <br />
              <br />
              <hr />
              <ul>
                <li
                  v-for="p in dialogEditPunchRecord.punchTimeline"
                  :key="p.time.seconds"
                >
                  <div style="margin-top: 15px;">
                    Punch {{ p.direction }}:
                    {{ p.time.toDate() | moment("MMM Do [at] h:mma") }} ({{
                      p.source
                    }}
                    by
                    <a :href="`mailto:${p.createdBy.email}`" target="_blank"
                      >{{ p.createdBy.firstName }} {{ p.createdBy.lastName }}</a
                    >)
                  </div>
                  <!-- On the punch itself, not at the top of the dialog: a row can
                       aggregate several punches and each has its own delete tick, so
                       a dialog-level warning did not say which one to leave alone.
                       Editing or deleting it orphans the dispute and takes the
                       employee's overtime explanation with it - that reason is stored
                       on the punch record and nowhere else. -->
                  <div v-if="p.hasPendingDispute" class="red--text caption">
                    <v-icon x-small class="red--text">gavel</v-icon>
                    This punch has a pending dispute. Please resolve there.
                  </div>
                  <v-checkbox
                    label="Delete Punch"
                    color="primary"
                    v-model="p.delete"
                    :value="false"
                    prepend-icon="delete"
                  ></v-checkbox>
                  <v-radio-group
                    v-model="p.newDirection"
                    row
                    prepend-icon="transfer_within_a_station"
                    style="margin-top: 0px;"
                  >
                    <v-radio label="Punch In" value="in"></v-radio>
                    <v-radio label="Punch Out" value="out"></v-radio>
                  </v-radio-group>
                  <!-- Blank unless deliberately set. Until now only the time could
                       be changed and the date came from the punch, so moving a
                       forgotten clock out back to the day it belongs to meant
                       deleting it and adding a new one - which is what orphans the
                       dispute and destroys the overtime reason stored on the punch. -->
                  <v-text-field
                    label="New Punch Date"
                    v-model="p.newDate"
                    type="date"
                    style="font-size:12px;min-height:40px"
                    color="primary"
                    outlined
                    class="tool-run-time"
                    prepend-icon="mdi-calendar"
                    hint="Leave blank to keep the current date"
                  ></v-text-field>
                  <v-text-field
                    label="New Punch Time"
                    v-model="p.newTime"
                    type="time"
                    style="font-size:12px;min-height:40px"
                    color="primary"
                    outlined
                    class="tool-run-time"
                    prepend-icon="mdi-clock"
                    hint="Leave blank to keep the current time"
                  ></v-text-field>
                  <!-- Lunch Section: Loop through each lunch object (flat array structure) -->
                  <template v-if="p.direction === 'out' && p.lunches && p.lunches.length > 0">
                    <div v-for="(lunch, lunchIdx) in p.lunches" :key="lunchIdx" style="margin-top: 10px;">
                      <!-- Lunch Taken (has time, no notes) - Display as read-only info -->
                      <template v-if="lunch.time && !lunch.notes">
                        <v-text-field
                          :label="'Lunch ' + (lunchIdx + 1)"
                          :value="lunch.time"
                          readonly
                          outlined
                          dense
                          disabled
                          prepend-icon="restaurant"
                          type="time"
                          style="margin-top: 10px;"
                        ></v-text-field>
                      </template>

                      <!-- No Lunch Claim (has notes or approvalStatus) - Always show editable form -->
                      <template v-else-if="lunch.notes || lunch.approvalStatus">
                        <v-radio-group
                          v-model="lunch.approvalStatus"
                          row
                          style="margin-top: 0px; margin-bottom: 0px;"
                        >
                          <template v-slot:prepend>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-on="on" v-bind="attrs">no_meals</v-icon>
                              </template>
                              <span>{{ lunch.notes || 'No reason provided' }}</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:label>
                            <span style="color: rgba(0, 0, 0, 0.87);">No Lunch {{ lunchIdx + 1 }}</span>
                          </template>
                          <v-radio label="Approve" value="approved"></v-radio>
                          <v-radio label="Deny" value="denied"></v-radio>
                        </v-radio-group>

                        <!-- Override: Show all three fields when denying no-lunch claim -->
                        <template v-if="lunch.approvalStatus === 'denied'">
                          <v-text-field
                            label="Employee's Claim"
                            :value="lunch.notes || 'No reason provided'"
                            readonly
                            outlined
                            dense
                            disabled
                            prepend-icon="chat_bubble"
                            style="margin-top: 10px;"
                          ></v-text-field>
                          <v-textarea
                            label="Employer's Response"
                            v-model="lunch.verificationNotes"
                            outlined
                            dense
                            rows="2"
                            prepend-icon="fact_check"
                            hint="Example: 'Lunch confirmed as taken via email with foreman John Montalvo'"
                            persistent-hint
                            style="margin-top: 10px;"
                          ></v-textarea>
                          <v-text-field
                            label="Actual Lunch Time"
                            v-model="lunch.overrideTime"
                            type="time"
                            outlined
                            dense
                            prepend-icon="restaurant"
                            style="margin-top: 10px;"
                          ></v-text-field>
                        </template>
                      </template>
                    </div>
                  </template>
                  <hr />
                </li>
              </ul>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogEditPunch = false">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                @click="editPunch"
                :loading="dialogAddPunchLoading"
                :disabled="dialogAddPunchLoading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogLeaderboard" max-width="490">
          <v-card>
            <v-card-title class="text-h5">
              Punch Leaderboard
            </v-card-title>
            <v-card-text>
              Displaying counts by punch source.
              <br />
              <br />
              <template>
                <v-data-table
                  :headers="leaderboardHeaders"
                  :items="leaderboard"
                  :items-per-page="10"
                  dense
                ></v-data-table>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogLeaderboard = false">
                    Close
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Location Leaderboard Dialog -->
        <v-dialog v-model="dialogLocationStats" max-width="700">
          <v-card>
            <v-card-title class="text-h5">
              Punch Location Stats
            </v-card-title>
            <v-card-text>
              Displaying punch location accuracy by who did the clock in/out.
              <br />
              <br />
              <template>
                <v-data-table
                  :headers="locationStatsHeaders"
                  :items="locationStats"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:item.green="{ item }">
                    <v-chip small color="green" text-color="white">{{ item.green }}</v-chip>
                  </template>
                  <template v-slot:item.orange="{ item }">
                    <v-chip small color="orange" text-color="white">{{ item.orange }}</v-chip>
                  </template>
                  <template v-slot:item.red="{ item }">
                    <v-chip small color="red" text-color="white">{{ item.red }}</v-chip>
                  </template>
                  <template v-slot:item.error="{ item }">
                    <v-chip small color="gray" text-color="black">{{ item.error }}</v-chip>
                  </template>
                </v-data-table>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogLocationStats = false">
                    Close
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Employee Note Dialog -->
        <v-dialog v-model="dialogEmployeeNote" max-width="500px" persistent>
          <v-card>
            <v-card-title class="text-h5">
              Add Employee Note
            </v-card-title>
            <v-card-text v-if="selectedEmployee">
              <div class="mb-3">
                <strong>Employee:</strong> {{ selectedEmployee.firstName }}
                {{ selectedEmployee.lastName }}
                <br />
                <strong>Badge ID:</strong> {{ selectedEmployee.barcodeId }}
              </div>
              <v-textarea
                v-model="newEmployeeNote"
                label="Add a note for this employee"
                outlined
                rows="4"
                :disabled="savingEmployeeNote"
                ref="employeeNoteTextarea"
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="cancelEmployeeNote"
                :disabled="savingEmployeeNote"
              >
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                @click="saveEmployeeNote"
                :loading="savingEmployeeNote"
                :disabled="!newEmployeeNote.trim() || savingEmployeeNote"
              >
                Save Note
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Employee Notes List Dialog -->
        <v-dialog v-model="dialogEmployeeNotesList" max-width="800px">
          <v-card>
            <v-card-title class="text-h5">
              Employee Notes
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogEmployeeNotesList = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-if="selectedEmployee">
              <div class="mb-4">
                <strong>Employee:</strong> {{ selectedEmployee.firstName }}
                {{ selectedEmployee.lastName }}
                <br />
                <strong>Badge ID:</strong> {{ selectedEmployee.barcodeId }}
              </div>

              <!-- Loading state -->
              <div v-if="loadingEmployeeNotes" class="text-center py-4">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <div class="mt-2">Loading notes...</div>
              </div>

              <!-- Notes list -->
              <div v-else-if="employeeNotes.length > 0">
                <v-card
                  v-for="note in employeeNotes"
                  :key="note.docId"
                  outlined
                  class="mb-3 pa-3"
                >
                  <div class="mb-2" style="white-space: pre-line;">
                    {{ note.note }}
                  </div>
                  <div class="caption grey--text">
                    By {{ note.createdByName || "Unknown User" }} on
                    <span v-if="note.createDate">{{
                      note.createDate | moment("MMM Do YYYY, h:mm A")
                    }}</span>
                  </div>
                </v-card>
              </div>

              <!-- No notes message -->
              <div v-else class="text-center grey--text py-4">
                No notes found for this employee.
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import fb from "@/main";
import { mapState } from "vuex";
import moment from "moment";
import JobSelector from "../components/JobSelector";
import SelfieThumbnail from "../components/payroll/SelfieThumbnail";
import PunchLocation from "../components/payroll/PunchLocation";

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export default {
  components: {
    JobSelector,
    SelfieThumbnail,
    PunchLocation,
  },
  data: () => {
    return {
      newJobSite: null,
      newPunchInTime: null,
      newPunchOutTime: null,
      bulkChangeLoading: false,
      deleteDialog: false,
      dialogJobChange: false,
      dialogPunchDirectionChange: false,
      dialogPunchTimeChange: false,
      page: 1,
      search: "",
      loading: false,
      table: [],
      fullTable: [],
      selected: [],
      filter: {
        dates: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        barcodeId: undefined,
        jobSite: undefined,
        punchDirection: "in & out",
        department: [],
        locationStatus: null,
        includeTerminated: false,
      },
      locationStatusOptions: [
        { text: 'All Locations', value: null },
        { text: 'On Site (Green)', value: 'green' },
        { text: 'Nearby (Orange)', value: 'orange' },
        { text: 'Far from Site (Red)', value: 'red' },
        { text: 'Not On Site (Orange/Red)', value: 'not-green' },
      ],
      dialogAddPunch: false,
      dialogEditPunch: false,
      dialogEditPunchRecord: {},
      // Punch document ids with an unresolved dispute against them, rebuilt whenever
      // the grid loads
      pendingDisputePunchIds: new Set(),
      dialogAddPunchRecord: { jobSite: null, employeeDocIds: [] },
      dialogAddPunchLoading: false,
      dialogEditPunchLoading: false,
      addPunchRecordMenu: false,
      dialogDatePicker: false,
      leaderboard: [],
      dialogLeaderboard: false,
      locationStats: [],
      dialogLocationStats: false,
      snack: false,
      snackText: "",
      snackColor: undefined,
      // Employee note dialog
      dialogEmployeeNote: false,
      selectedEmployee: null,
      newEmployeeNote: "",
      savingEmployeeNote: false,
      // Employee notes list dialog
      dialogEmployeeNotesList: false,
      employeeNotes: [],
      loadingEmployeeNotes: false,
      tableHeaders: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "barcodeId",
          width: 70,
        },
        {
          text: "Employee",
          align: "start",
          sortable: true,
          width: 175,
          value: "employee.name",
        },
        {
          text: "Job Site",
          align: "start",
          sortable: true,
          width: 200,
          value: "jobSiteName",
        },
        {
          text: "Date",
          align: "start",
          width: 80,
          sortable: true,
          value: "date",
        },
        {
          text: "Rate",
          align: "start",
          width: 80,
          sortable: true,
          value: "rate",
        },
        {
          text: "Hours",
          align: "start",
          sortable: true,
          width: 100,
          value: "hours",
        },
        {
          text: "Wages",
          align: "start",
          width: 100,
          sortable: true,
          value: "wages",
        },
        {
          text: "Timeline",
          align: "start",
          sortable: false,
          width: 270,
          value: "punchTimeline",
        },
        // {
        //   text: "Selfie",
        //   align: "start",
        //   sortable: false,
        //   width: 50,
        //   value: "selfie",
        // },
        // {
        //   text: "Started",
        //   align: "start",
        //   width: 110,
        //   value: "startDate",
        // },
        {
          text: "Error",
          align: "start",
          sortable: true,
          width: 85,
          value: "error",
        },
        {
          text: "NS",
          align: "center",
          sortable: true,
          width: 80,
          value: "ns",
        },
        {
          text: "In",
          align: "start",
          sortable: true,
          width: 120,
          value: "early",
        },
        {
          text: "Out",
          align: "start",
          sortable: true,
          width: 120,
          value: "late",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "edit",
        },
      ],
      leaderboardHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Camera",
          align: "start",
          sortable: false,
          value: "camera",
        },
        {
          text: "Manual",
          align: "start",
          sortable: false,
          value: "manual",
        },
      ],
      locationStatsHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "On Site",
          align: "center",
          sortable: true,
          value: "green",
        },
        {
          text: "Nearby",
          align: "center",
          sortable: true,
          value: "orange",
        },
        {
          text: "Far",
          align: "center",
          sortable: true,
          value: "red",
        },
        {
          text: "Error",
          align: "center",
          sortable: true,
          value: "error",
        }
      ],
    };
  },
  async created() {
    if (!this.employees.length) {
      await this.$store.dispatch("getEmployees", fb);
      if (!this.jobSites.length) {
        await this.$store.dispatch("getJobSitesOpenClosed", fb);
      }
      await this.$store.dispatch("getEmployees", fb);
    }
    if (!this.employeesWithTerminated.length) {
      await this.$store.dispatch("getAllEmployees", fb);
    }
    if (!this.payroll.length) {
      await this.$store.dispatch("getPayroll", fb);
    }
    this.getTable();
  },
  computed: {
    ...mapState({
      user: "user",
      employees: "employees",
      employeesWithTerminated: "allEmployees",
      payroll: "payroll",
      jobSites: "jobSitesOpenClosed",
    }),
    dateRangeText: function() {
      return this.filter.dates.join(" ~ ");
    },
    allEmployees: function() {
      const source = this.filter.includeTerminated
        ? this.employeesWithTerminated
        : this.employees;
      return source.map((e) => {
        return {
          name: `${e.firstName} ${e.lastName} (${e.barcodeId})`,
          ...e,
        };
      });
    },
    allPayroll: function() {
      return this.payroll.map((p) => {
        return {
          ...p,
        };
      });
    },
    multiSelectCount: function() {
      return this.selected.map((t) => t.barcodeId).filter(onlyUnique).length;
    },
    oppositePunchDirection: function() {
      const opposite = {
        in: "out",
        out: "in",
      };
      return opposite[this.filter.punchDirection];
    },
    forceJobSiteId: function() {
      // limit job sites by role or user
      // jobid on right
      const userRoleJobSiteIdMap = {
        "Equipment Manager": "nAtZ572ilArL5p3Zs5GK",
        "ronan@albademo.com": "MvtgmGs5g6iq6pV1sc5m",
      };
      return (
        userRoleJobSiteIdMap[this.user.role] ||
        userRoleJobSiteIdMap[this.user.email] ||
        null
      );
    },
    activeDepartments: function() {
      const departments = this.fullTable.map((t) => {
        return t.code;
      });
      return [...new Set(departments)];
    },
    activePunchedInBy: function() {
      const punchedInBy = this.table.map((t) => {
        if (t.punchTimeline.length) {
          const creator = t.punchTimeline[0].createdBy || {};
          return `${creator.firstName || "Unknown"} ${creator.lastName || ""}`.trim();
        }
      });

      // Filtered and sorted: a row with no punch timeline mapped to undefined, which
      // survived the Set as a blank option that selected nothing. Harmless as one
      // stray line in a dropdown, misleading as the first hit in a typeahead.
      return [...new Set(punchedInBy)].filter(Boolean).sort((a, b) => a.localeCompare(b));
    },
    activelocationStatus: function() {
      const locationStatuses = this.table.map((t) => {
        const locationStatus = this.getRowLocationStatus(t);
        if (locationStatus) {
          return locationStatus;
        }
      });

      return [...new Set(locationStatuses)];
    },
    punchErrorCount: function() {
      return this.table.filter((t) => t.error).length;
    },
  },
  methods: {
    filterByName(value, search, item) {
      const searchTerm = search.toLowerCase();
      const barcodeId = (item.barcodeId || "").toString();
      const firstName = item.employee.firstName.toLowerCase().trim();
      const lastName = item.employee.lastName.toLowerCase().trim();
      return (
        firstName.indexOf(searchTerm) > -1 ||
        lastName.toLowerCase().indexOf(searchTerm) > -1 ||
        `${firstName} ${lastName}`.indexOf(searchTerm) > -1 ||
        barcodeId.indexOf(searchTerm) > -1
      );
    },
    updateFilterJobSite: function(evt) {
      this.filter.jobSite = (evt || {}).id;
      this.selected = [];
      if (this.filter.jobSite) {
        this.table = this.table.filter(
          (d) => d.jobSite === this.filter.jobSite
        );
      } else {
        this.getTable();
      }
    },
    updateFilterDepartment: function() {
      this.selected = [];
      this.getTable();
    },
    updateFilterIncludeTerminated: function() {
      this.selected = [];
      this.getTable();
    },
    updateFilterPunchedInBy: function() {
      this.selected = [];
      if (this.filter.punchedInBy) {
        this.table = this.table.filter((t) => {
          const creator = t.punchTimeline[0].createdBy || {};
          return (
            `${creator.firstName || "Unknown"} ${creator.lastName || ""}`.trim() ===
            this.filter.punchedInBy
          );
        });
      } else {
        this.getTable();
      }
    },
    updateFilterPunchDirection: function() {
      this.selected = [];
      this.getTable();
    },
    updateFilterLocationStatus: function() {
      this.selected = [];
      if (this.filter.locationStatus) {
        this.table = this.table.filter((t) => {
          const locationStatus = this.getRowLocationStatus(t);
          return locationStatus === this.filter.locationStatus;
        });
      } else {
        this.getTable();
      }
    },
    calculateDistance: function(lat1, lon1, lat2, lon2) {
      // Calculate distance using Haversine formula
      const R = 6371e3; // Earth's radius in meters
      const φ1 = (lat1 * Math.PI) / 180;
      const φ2 = (lat2 * Math.PI) / 180;
      const Δφ = ((lat2 - lat1) * Math.PI) / 180;
      const Δλ = ((lon2 - lon1) * Math.PI) / 180;

      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c; // Returns distance in meters
    },
    getRowLocationStatus: function(row) {
      // Find the first punch with a pre-calculated location type
      const punchWithLocationType = row.punchTimeline.find(
        (p) => p.locationType
      );

      return punchWithLocationType ? punchWithLocationType.locationType : null;
    },
    toggleDialogAddPunch: function() {
      this.dialogAddPunchRecord.employeeDocIds = this.selected
        .map((t) => t.employee.docId)
        .filter(onlyUnique);
      this.dialogAddPunch = true;
    },
    addPunch: async function() {
      const missingValues = [];
      if (!this.dialogAddPunchRecord.direction) {
        missingValues.push("Punch Direction");
      }
      if (!this.dialogAddPunchRecord.employeeDocIds.length) {
        missingValues.push("Employee");
      }
      if (!this.dialogAddPunchRecord.jobSite && !this.forceJobSiteId) {
        missingValues.push("Job");
      }
      if (!this.dialogAddPunchRecord.date) {
        missingValues.push("Date");
      }
      if (!this.dialogAddPunchRecord.time) {
        missingValues.push("Time");
      }
      if (missingValues.length) {
        alert(`Please provide the missing values: ${missingValues.join(", ")}`);
        return;
      }

      try {
        this.dialogAddPunchLoading = true;
        const datetime = new Date(
          `${this.dialogAddPunchRecord.date} ${this.dialogAddPunchRecord.time}`
        );
        const employeeDocIds = this.dialogAddPunchRecord.employeeDocIds.filter(
          onlyUnique
        );
        for (let i = 0; i < employeeDocIds.length; i++) {
          const employeeDocId = employeeDocIds[i];
          const obj = {
            employee: employeeDocId,
            direction: this.dialogAddPunchRecord.direction,
            jobSite:
              this.forceJobSiteId || this.dialogAddPunchRecord.jobSite.id,
            source: "manual",
            time: datetime,
            createdBy: this.user.uid,
          };
          await fb.db.collection("punchRecords").add(obj);
        }

        this.snack = true;
        this.snackText = `Success adding punch record(s).`;
        this.snackColor = "success";
        this.dialogAddPunch = false;
        if (!this.forceJobSiteId) {
          this.$refs.dialogJobSelectorRef.clearJobSite();
        }
        this.dialogAddPunchRecord = { jobSite: null, employeeDocIds: [] };
        this.selected = [];
        this.getTable();
      } catch (e) {
        this.snack = true;
        this.snackText = `Error adding punch record(s).`;
        this.snackColor = "error";
        console.log("addPunch error", e);
      }
      this.dialogAddPunchLoading = false;
    },
    showEditPunchDialog: function(item) {
      // Initialize lunch data for each punch (flat lunch array structure)
      if (item.punchTimeline) {
        item.punchTimeline.forEach(punch => {
          // Fix corrupted lunches (object instead of array due to Firestore dot notation bug)
          if (punch.lunches && typeof punch.lunches === 'object' && !Array.isArray(punch.lunches)) {
            // Convert object to array: { "0": {...}, "1": {...} } => [{...}, {...}]
            punch.lunches = Object.values(punch.lunches);
          }

          // Initialize lunches array if it doesn't exist
          if (!punch.lunches) {
            punch.lunches = [];
          }

          // For each lunch object, add UI-specific fields
          punch.lunches.forEach((lunch, index) => {
            // If this lunch has notes OR approvalStatus (no-lunch claim), initialize approval UI fields
            if (lunch && (lunch.notes || lunch.approvalStatus)) {
              lunch.lunchIndex = index;
              lunch.notes = lunch.notes || '';  // Ensure notes field exists
              lunch.overrideTime = lunch.overrideTime || '';
              lunch.verificationNotes = lunch.verificationNotes || '';
              lunch.approvalStatus = lunch.approvalStatus || 'pending';
            }
          });
        });
      }
      this.dialogEditPunchRecord = item;
      this.dialogEditPunch = true;
    },
    editPunch: async function() {
      try {
        this.dialogAddPunchLoading = true;

        const punchDocIds = this.dialogEditPunchRecord.punchTimeline
          .filter((p) => p.delete)
          .map((p) => p.punchDocId);
        for (let i = 0; i < punchDocIds.length; i++) {
          const punchDocId = punchDocIds[i];
          const res = await fb.db
            .collection("punchRecords")
            .doc(punchDocId)
            .delete();
        }

        // punches eligible for updating
        const punches = this.dialogEditPunchRecord.punchTimeline.filter(
          (p) => !p.delete
        );
        for (let i = 0; i < punches.length; i++) {
          const punch = punches[i];
          const obj = {};
          // Either field on its own is a valid change, so each part falls back to
          // what the punch already holds. Built from components rather than by
          // parsing a formatted string back into a Date, which is what the old
          // time-only path did.
          if (punch.newTime || punch.newDate) {
            const current = punch.time.toDate();
            let year = current.getFullYear();
            let month = current.getMonth();
            let day = current.getDate();
            let hours = current.getHours();
            let minutes = current.getMinutes();

            if (punch.newDate) {
              const parts = punch.newDate.split("-").map(Number);
              year = parts[0];
              month = parts[1] - 1;
              day = parts[2];
            }
            if (punch.newTime) {
              const parts = punch.newTime.split(":").map(Number);
              hours = parts[0];
              minutes = parts[1];
            }

            obj.time = new Date(year, month, day, hours, minutes, 0, 0);
          }
          if (punch.newDirection && punch.newDirection != punch.direction) {
            obj.direction = punch.newDirection;
          }

          // Handle lunch approvals (flat array structure)
          // IMPORTANT: Must update entire array, not use dot notation (lunches.0.field)
          // because Firestore converts arrays to objects when using dot notation
          if (punch.lunches && Array.isArray(punch.lunches) && punch.lunches.length > 0) {
            // Check if any lunch has changes
            let hasLunchChanges = false;
            const updatedLunches = punch.lunches.map((lunch, lunchIdx) => {
              if (lunch.notes && lunch.approvalStatus) {
                // Validate required fields when denying
                if (lunch.approvalStatus === 'denied') {
                  if (!lunch.overrideTime || !lunch.overrideTime.trim()) {
                    throw new Error(`Actual lunch time is required when denying lunch ${lunchIdx + 1}`);
                  }
                  if (!lunch.verificationNotes || !lunch.verificationNotes.trim()) {
                    throw new Error(`Employer's response is required when denying lunch ${lunchIdx + 1}`);
                  }
                }

                hasLunchChanges = true;

                // Return updated lunch object (exclude UI-only properties like 'editing' and 'lunchIndex')
                if (lunch.approvalStatus === 'denied') {
                  const { editing, lunchIndex, ...lunchData } = lunch;
                  return {
                    ...lunchData,
                    approvalStatus: lunch.approvalStatus,
                    overrideTime: lunch.overrideTime,
                    verificationNotes: lunch.verificationNotes,
                    verifiedBy: this.user.uid,
                    verifiedAt: new Date(),
                  };
                } else if (lunch.approvalStatus === 'approved') {
                  const { editing, lunchIndex, ...lunchData } = lunch;
                  return {
                    ...lunchData,
                    approvalStatus: lunch.approvalStatus,
                    overrideTime: null,
                    verificationNotes: null,
                    verifiedBy: this.user.uid,
                    verifiedAt: new Date(),
                  };
                }
              }
              // Return unchanged lunch object (preserves lunches with just 'time' field)
              return lunch;
            });

            // If there were changes, update the entire lunches array
            if (hasLunchChanges) {
              obj.lunches = updatedLunches;
            }
          }
          if (Object.keys(obj).length) {
            obj.editedBy = this.user.uid;

            await fb.db
              .collection("punchRecords")
              .doc(punch.punchDocId)
              .update(obj);
          }
        }

        this.getTable();
        this.dialogEditPunch = false;
        this.snack = true;
        this.snackText = `Success editing punch record(s).`;
        this.snackColor = "success";
      } catch (e) {
        this.snack = true;
        this.snackText = `Error editing punch record(s).`;
        this.snackColor = "error";
        // eslint-disable-next-line no-console
        console.log("editPunch error", e);
      }
      this.dialogAddPunchLoading = false;
    },
    getCsv: function() {
      try {
        const csvData = [];
        this.table.forEach((t) => {
          if (!t.error) {
            csvData.push({
              Employee: `${t.employee.lastName}, ${t.employee.firstName}`,
              Code: t.code,
              Rate: t.rate,
              "Job Site": t.jobSiteName,
              Date: t.date,
              Hours: t.hours,
              "Total Wages": t.wages,
              "Punch In": moment(
                t.punchTimeline[0].date,
                "M/D/YYYY, h:mm:ss A"
              ).format("h:mm A"),
              "Punch Out": moment(
                t.punchTimeline[1].date,
                "M/D/YYYY, h:mm:ss A"
              ).format("h:mm A"),
              Foreman: `${t.punchTimeline[0].createdBy.firstName} ${t.punchTimeline[0].createdBy.lastName}`,
            });
          }
        });

        if (!csvData.length) {
          alert("No data was found. Try again.");
          return;
        }

        const replacer = (key, value) => (value === null ? "" : `${value}`); // specify how you want to handle null values here
        const header = Object.keys(csvData[0]);
        const csvFile = [
          header.join(","), // header row first
          ...csvData.map((row) =>
            header
              .map((fieldName) => JSON.stringify(row[fieldName], replacer))
              .join(",")
          ),
        ].join("\r\n");

        // START setup for downloading csv blob
        const filename = `report-${new Date().getTime()}.csv`;
        const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, filename);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
        // END setup for downloading csv blob
      } catch (e) {
        alert("No data was found. Try again.");
        // eslint-disable-next-line no-console
        console.log("getCsv error", e);
      }
    },
    async deleteRows() {
      try {
        this.bulkChangeLoading = true;
        const punchDocIds = this.selected
          .map((s) => s.punchTimeline.map((pt) => pt.punchDocId))
          .flat();
        const batch = fb.db.batch();
        punchDocIds.forEach((s) => {
          var ref = fb.db.collection("punchRecords").doc(s);
          batch.delete(ref);
        });
        await batch.commit();
        this.selected = [];
        this.bulkChangeLoading = false;
        this.deleteDialog = false;
        this.getTable();
      } catch (error) {
        this.bulkChangeLoading = false;
        this.deleteDialog = false;
        console.log("deleteRows error", error);
        this.snack = true;
        this.snackText = `Error deleting rows.`;
        this.snackColor = "error";
      }
    },
    async punchDirectionChangeRows() {
      try {
        this.bulkChangeLoading = true;
        const punchDocIds = this.selected
          .map((s) => s.punchTimeline.map((pt) => pt.punchDocId))
          .flat();
        const batch = fb.db.batch();
        punchDocIds.forEach((s) => {
          var ref = fb.db.collection("punchRecords").doc(s);
          batch.update(ref, { direction: this.oppositePunchDirection });
        });
        await batch.commit();
        this.selected = [];
        this.bulkChangeLoading = false;
        this.dialogPunchDirectionChange = false;
        this.getTable();
      } catch (error) {
        this.bulkChangeLoading = false;
        console.log("punchDirectionChangeRows error", error);
        this.snack = true;
        this.snackText = `Error changing punch direction for selected rows.`;
        this.snackColor = "error";
      }
    },
    async punchTimeChangeRows() {
      try {
        const punches = [];
        this.selected.forEach((s) => {
          s.punchTimeline.forEach((pt) => {
            if (pt.direction === "in" && this.newPunchInTime) {
              punches.push({
                docId: pt.punchDocId,
                time: new Date(
                  `${new Date(pt.date).toLocaleDateString("en-US")} ${
                    this.newPunchInTime
                  }`
                ),
              });
            }
            if (pt.direction === "out" && this.newPunchOutTime) {
              punches.push({
                docId: pt.punchDocId,
                time: new Date(
                  `${new Date(pt.date).toLocaleDateString("en-US")} ${
                    this.newPunchOutTime
                  }`
                ),
              });
            }
          });
        });

        if (!punches.length) {
          this.newPunchInTime = null;
          this.newPunchOutTime = null;
          return;
        }
        this.bulkChangeLoading = true;
        const batch = fb.db.batch();
        punches.forEach((p) => {
          var ref = fb.db.collection("punchRecords").doc(p.docId);
          batch.update(ref, { time: p.time });
        });
        await batch.commit();
        this.selected = [];
        this.newPunchInTime = null;
        this.newPunchOutTime = null;
        this.bulkChangeLoading = false;
        this.dialogPunchTimeChange = false;
        this.snack = true;
        this.snackText = `Success updating punch record(s).`;
        this.snackColor = "success";
        this.getTable();
      } catch (error) {
        this.bulkChangeLoading = false;
        console.log("punchTimeChangeRows error", error);
        this.snack = true;
        this.snackText = `Error changing punch direction for selected rows.`;
        this.snackColor = "error";
      }
    },
    async jobChangeRows() {
      try {
        this.bulkChangeLoading = true;
        const punchDocIds = this.selected
          .map((s) => s.punchTimeline.map((pt) => pt.punchDocId))
          .flat();
        const batch = fb.db.batch();
        punchDocIds.forEach((s) => {
          var ref = fb.db.collection("punchRecords").doc(s);
          batch.update(ref, { jobSite: this.newJobSite.id });
        });
        await batch.commit();
        this.selected = [];
        this.$refs.dialogJobSelectorRef.clearJobSite();
        this.bulkChangeLoading = false;
        this.dialogJobChange = false;
        this.getTable();
      } catch (error) {
        this.bulkChangeLoading = false;
        console.log("jobChangeRows error", error);
        this.snack = true;
        this.snackText = `Error changing jobs site for selected rows.`;
        this.snackColor = "error";
      }
    },
    getTable: async function() {
      try {
        this.loading = true;
        this.table = [];

        const dates = this.filter.dates.map((d) => {
          return new Date(d + "T00:00:00");
        });

        // start & end date of range selector
        const endDate = moment(Math.max.apply(null, dates))
          .endOf("day")
          .toDate();
        const startDate = moment(Math.min.apply(null, dates))
          .startOf("day")
          .toDate();
        // one day before & after the range selector
        const endDatePlusOne = moment(Math.max.apply(null, dates))
          .add(1, "d")
          .endOf("day")
          .toDate();
        const startDateMinusOne = moment(Math.min.apply(null, dates))
          .subtract(1, "d")
          .startOf("day")
          .toDate();

        let punRes = [];

        if (this.forceJobSiteId) {
          punRes = await fb.db
            .collection("punchRecords")
            .where("time", ">=", startDateMinusOne)
            .where("time", "<=", endDatePlusOne)
            .where("jobSite", "==", this.forceJobSiteId)
            .orderBy("time", "desc")
            .get();
        } else {
          punRes = await fb.db
            .collection("punchRecords")
            .where("time", ">=", startDateMinusOne)
            .where("time", "<=", endDatePlusOne)
            .orderBy("time", "desc")
            .get();
        }

        // Which punches have an unresolved dispute against them. Editing or deleting
        // one of these is how a dispute ends up pointing at nothing, and how the
        // employee's overtime explanation - which lives on the punch record - gets
        // destroyed before anyone reads it.
        //
        // The whole collection is read and filtered here rather than queried: a
        // dispute is pending when disputeStatus is "pending" OR absent, and Firestore
        // cannot express that as one query.
        const pendingDisputePunchIds = new Set();
        try {
          const dispRes = await fb.db.collection("employeeAppPunchDisputes").get();
          dispRes.forEach((r) => {
            const d = r.data();
            if (d.disputeStatus && d.disputeStatus !== "pending") return;
            // Both ids on a legacy pair record, where one dispute covered two punches
            if (d.punchInId) pendingDisputePunchIds.add(d.punchInId);
            if (d.punchOutId) pendingDisputePunchIds.add(d.punchOutId);
          });
        } catch (err) {
          // A failure here must not take payroll's grid down - it just means no flags
          console.warn("Could not load disputes for punch flags:", err);
        }
        this.pendingDisputePunchIds = pendingDisputePunchIds;

        const dateFormat = function(seconds) {
          return new Date(seconds * 1000).toLocaleDateString("en-US");
        };

        const datetimeFormat = function(seconds) {
          return new Date(seconds * 1000).toLocaleString("en-US");
        };

        const isPunchBetweenDateRange = function(punch, startDate, endDate) {
          // core date range from selector... no 1 day before and no 1 day after buffer
          return (
            new Date(dateFormat(punch.time.seconds)) <= endDate &&
            new Date(dateFormat(punch.time.seconds)) >= startDate
          );
        };

        const getLeaderboardStats = function(table) {
          // build up source stats (camera or manual) for leaderboard
          const leaderboardMap = {};
          table.forEach((row) => {
            row.punchTimeline.forEach((punch) => {
              // createdBy can be undefined if the punch's creator user record
              // is missing/deleted — fall back to "Unknown" instead of crashing
              const creator = punch.createdBy || {};
              const fullName = `${creator.firstName || "Unknown"} ${creator.lastName ||
                ""}`.trim();
              if (!leaderboardMap[fullName]) {
                leaderboardMap[fullName] = { camera: 0, manual: 0 };
              }
              if (punch.source && leaderboardMap[fullName][punch.source] !== undefined) {
                leaderboardMap[fullName][punch.source] += 1;
              }
            });
          });
          return Object.keys(leaderboardMap)
            .map((key) => {
              return { name: key, ...leaderboardMap[key] };
            })
            .sort(function(a, b) {
              return b.manual - a.manual;
            });
        };

        const getLocationStats = (table) => {
          // build up location stats (green/orange/red/error) by who did the punch
          const locationMap = {};
          table.forEach((row) => {
            row.punchTimeline.forEach((punch) => {
              // createdBy can be undefined if the creator user record is missing
              const creator = punch.createdBy || {};
              const fullName = `${creator.firstName || "Unknown"} ${creator.lastName ||
                ""}`.trim();
              if (!locationMap[fullName]) {
                locationMap[fullName] = { green: 0, orange: 0, red: 0, error: 0 };
              }

              // Use pre-calculated location type
              if (punch.locationType) {
                locationMap[fullName][punch.locationType] += 1;
              }
            });
          });

          return Object.keys(locationMap)
            .map((key) => {
              return { name: key, ...locationMap[key] };
            })
            .sort(function(a, b) {
              // Sort by highest green count (best location accuracy)
              return b.green - a.green;
            });
        };

        // const getHoursDeducted = function(hours) {
        //   // what is known as a lunch rule
        //   // 8.5 to 15.99, .5 hour deducted
        //   // 16 to 23.5, 1 hour deducted
        //   if (hours >= 16 && hours <= 23.5) {
        //     return 1;
        //   }
        //   if (hours >= 8.5 && hours < 16) {
        //     return 0.5;
        //   }
        //   return 0;
        // };

        const getHoursDeducted = function(hours, ignoreLunchRule = false) {
          if (ignoreLunchRule || !hours || hours < 6) {
            return 0; // No deduction if ignoreLunchRule is true or hours are less than 6
          }

          // Deduct 0.5 hours for every 6 hours worked
          return Math.floor(hours / 6) * 0.5;
        };

        // const hoursRound = function(hours) {
        //   // 30-minute (0.5-hour) intervals
        //   if (!hours) {
        //     return hours;
        //   }

        //   const decimal = hours.toString().split(".")[1] || 0;
        //   const remainder = `${0}.${decimal}`;

        //   if (!remainder) {
        //     return hours; // no rounding required
        //   }
        //   if (remainder < 0.25 || (remainder >= 0.5 && remainder < 0.75)) {
        //     return Math.floor(hours * 2) / 2; // round down to nearest .5
        //   }
        //   return Math.ceil(hours * 2) / 2; // round up to nearest .5
        // };

        // const hoursRound = function(hours) {
        //   // 15-minute (0.25-hour) intervals
        //   if (!hours) {
        //     return hours;
        //   }

        //   const decimal = hours.toString().split(".")[1] || 0;
        //   const remainder = parseFloat(`0.${decimal}`);

        //   if (!remainder) {
        //     return hours; // no rounding required
        //   }

        //   // Check rounding conditions based on 15-minute (0.25-hour) intervals
        //   if (remainder < 0.125 || (remainder >= 0.375 && remainder < 0.625)) {
        //     return Math.floor(hours * 4) / 4; // round down to nearest 0.25
        //   }

        //   return Math.ceil(hours * 4) / 4; // round up to nearest 0.25
        // };

        // Helper function to round time to nearest 15 minutes
        const roundToNearestQuarterHour = function(momentTime) {
          return momentTime
            .minute(Math.round(momentTime.minute() / 15) * 15)
            .second(0);
        };

        // Helper function to calculate hours between two punches with 15-min rounding
        const calculateShiftHours = function(punchIn, punchOut) {
          const punchInTime = moment(punchIn.time.toDate());
          const punchOutTime = moment(punchOut.time.toDate());

          const roundedPunchIn = roundToNearestQuarterHour(punchInTime);
          const roundedPunchOut = roundToNearestQuarterHour(punchOutTime);

          return roundedPunchOut.diff(roundedPunchIn, "hours", true);
        };

        // Helper function to round total hours to nearest 0.25-hour interval
        const roundToQuarterHour = function(totalHours) {
          const fixedHours = parseFloat(totalHours.toFixed(3));
          const decimal = fixedHours.toString().split(".")[1] || 0;
          const remainder = parseFloat(`0.${decimal}`);

          if (!remainder) {
            return fixedHours;
          }

          if (remainder < 0.125 || (remainder >= 0.375 && remainder < 0.625)) {
            return Math.floor(fixedHours * 4) / 4;
          }

          return Math.ceil(fixedHours * 4) / 4;
        };

        // round hours to nearest 15 minutes on punch in and out separately
        const hoursRoundv2 = function(hours, punchTimeline) {
          if (!hours || !punchTimeline || punchTimeline.length < 2) {
            return hours;
          }

          // Handle split shifts - if exactly 4 punches (2 in, 2 out)
          if (punchTimeline.length === 4) {
            const inPunches = punchTimeline.filter((p) => p.direction === "in");
            const outPunches = punchTimeline.filter((p) => p.direction === "out");

            if (inPunches.length === 2 && outPunches.length === 2) {
              const shift1Hours = calculateShiftHours(inPunches[0], outPunches[0]);
              const shift2Hours = calculateShiftHours(inPunches[1], outPunches[1]);
              return roundToQuarterHour(shift1Hours + shift2Hours);
            }
          }

          // Regular shifts (2 punches)
          const shiftHours = calculateShiftHours(punchTimeline[0], punchTimeline[1]);
          return roundToQuarterHour(shiftHours);
        };

        // const hoursRound = function(hours) {
        //   // no rounding
        //   if (!hours) {
        //     return hours;
        //   }

        //   return Math.round(hours * 100) / 100;
        // };

        // get employee punches
        const userIds = [];
        const jobSiteIds = [];
        let punches = [];
        punRes.forEach((r) => {
          const obj = r.data();
          obj.punchDocId = r.id;
          if (userIds.indexOf(obj.createdBy) === -1)
            userIds.push(obj.createdBy);
          if (userIds.indexOf(obj.editedBy) === -1 && obj.editedBy)
            userIds.push(obj.editedBy);
          if (jobSiteIds.indexOf(obj.jobSite) === -1)
            jobSiteIds.push(obj.jobSite);
          obj.date = datetimeFormat(obj.time.seconds);
          obj.hasPendingDispute = pendingDisputePunchIds.has(obj.punchDocId);

          // Convert GeoPoint to geolocationData object for component compatibility
          if (obj.geolocation && obj.geolocation.latitude !== undefined && obj.geolocation.longitude !== undefined) {
            obj.geolocationData = {
              latitude: obj.geolocation.latitude,
              longitude: obj.geolocation.longitude,
              accuracy: obj.geolocationAccuracy || null,
            };
          } else if (obj.geolocationError) {
            // Handle location errors
            obj.geolocationData = {
              error: obj.geolocationError,
              errorMessage: obj.geolocationErrorMessage,
            };
          }

          punches.push(obj);
        });

        if (["in", "out"].indexOf(this.filter.punchDirection) > -1) {
          punches = punches.filter(
            (p) => p.direction == this.filter.punchDirection
          );
        }

        if (this.filter.jobSite) {
          punches = punches.filter((d) => d.jobSite === this.filter.jobSite);
        }

        if (!punches.length) {
          this.loading = false;
          return;
        }
        const jobSiteMap = {};
        jobSiteIds.forEach((id) => {
          jobSiteMap[id] = this.jobSites.find((j) => j.id == id);
        });
        const userIdsMap = {};
        const res = await fb.db.collection("users").get();
        res.forEach((r) => {
          const data = r.data();
          if (userIds.includes(data.uid)) {
            userIdsMap[r.id] = data;
          }
        });

        punches.forEach((punch) => {
          // For employee-app self-punches, use the employee field to get the name
          // For regular punches, use createdBy to look up the user
          let creator = userIdsMap[punch.createdBy];
          if (!creator && punch.source === 'employee-app' && punch.employee) {
            // For employee-app punches, get the name from the employee record
            const emp = this.allEmployees.find(
              (e) => e.docId === punch.employee
            );
            if (emp) {
              creator = {
                firstName: emp.firstName,
                lastName: emp.lastName,
                email: emp.email,
              };
            }
          }
          punch.createdBy = creator;
          punch.editedBy = userIdsMap[punch.editedBy];

          // Calculate distance and determine location status
          if (punch.geolocationData && punch.geolocationData.error) {
            punch.locationType = 'error';
          } else if (punch.geolocationData &&
              punch.geolocationData.latitude !== undefined &&
              punch.geolocationData.longitude !== undefined) {
            const jobSite = jobSiteMap[punch.jobSite];
            if (jobSite && jobSite.geolocation) {
              punch.distanceMeters = this.calculateDistance(
                punch.geolocationData.latitude,
                punch.geolocationData.longitude,
                jobSite.geolocation.latitude,
                jobSite.geolocation.longitude
              );

              // Set location type based on distance thresholds
              if (punch.distanceMeters < 300) {
                punch.locationType = 'green'; // On site
              } else if (punch.distanceMeters < 500) {
                punch.locationType = 'orange'; // Nearby
              } else {
                punch.locationType = 'red'; // Far from site
              }
            }
          }
        });

        const punchMap = {};

        // process only punches in the selectors exact date range
        // const punches from firebase holds punches from 1 day before and 1 day after the selector range
        // we can utilize const punches below in previousPunches and postPunches
        const punchesBetweenDateRange = punches.filter((p) =>
          isPunchBetweenDateRange(p, startDate, endDate)
        );
        punchesBetweenDateRange.forEach((punch) => {
          const employee = this.allEmployees.find(
            (e) => e.docId === punch.employee
          );
          const pay = this.allPayroll.find((e) => e.docId === punch.employee);

          if (employee && pay) {
            const jobSiteName = `${(jobSiteMap[punch.jobSite] || {}).street} (${
              (jobSiteMap[punch.jobSite] || {}).jobId
            })`;
            const jobSiteDepartment =
              jobSiteMap[punch.jobSite].department || "";
            const ignoreLunchRule =
              jobSiteMap[punch.jobSite].ignoreLunchRule || false;
            const jobSite = punch.jobSite;
            const date = dateFormat(punch.time.seconds);
            let error = "";

            const rateHistory = pay.rateHistory
              .filter((rh) => new Date(rh.effectiveDate) <= new Date(date))
              .sort(function(a, b) {
                return new Date(b.effectiveDate) - new Date(a.effectiveDate);
              });
            let rate = null;
            if (rateHistory.length) {
              rate = rateHistory[0].rate;
            }

            // get closest punches of same day and next day (+86400)
            const postPunches = punches
              .filter(function(p) {
                return (
                  p.employee === punch.employee &&
                  p.jobSite === punch.jobSite &&
                  (dateFormat(p.time.seconds) ===
                    dateFormat(punch.time.seconds) ||
                    dateFormat(p.time.seconds) ===
                      dateFormat(punch.time.seconds + 86400)) &&
                  p.time.seconds > punch.time.seconds
                );
              })
              .sort(function(a, b) {
                return a.time.seconds - b.time.seconds;
              });

            // get closest punches of same day and previous day (-86400)
            const previousPunches = punches
              .filter(function(p) {
                return (
                  p.employee === punch.employee &&
                  p.jobSite === punch.jobSite &&
                  (dateFormat(p.time.seconds) ===
                    dateFormat(punch.time.seconds) ||
                    dateFormat(p.time.seconds) ===
                      dateFormat(punch.time.seconds - 86400)) &&
                  p.time.seconds < punch.time.seconds
                );
              })
              .sort(function(a, b) {
                return b.time.seconds - a.time.seconds;
              });

            // set hours
            let hours = null;
            const punchTimeline = [];

            // this is the core logic to building out rows in the table
            if (punch.direction === "in") {
              // only push into timeline to generate a row if its a rogue 'in'
              // or it is an 'in' that is tied to a following 'out' that is either inside or one day past the core date range
              if (postPunches.length && postPunches[0].direction === "out") {
                const punchOut = postPunches[0];
                punchTimeline.push(punch);
                punchTimeline.push(punchOut);
                hours = (punchOut.time.seconds - punch.time.seconds) / 3600;
              } else {
                punchTimeline.push(punch);
                error = `Missing Punch Out`;
              }
            } else if (punch.direction === "out") {
              // only push into timeline to generate a row if its a rogue 'out'
              // or it is an 'out' tied to a previous 'in' from the day before the core date range
              // don't push into timeline if it is an 'out' tied to an 'in' inside the core date range...
              // ...this will create dupe rows because the above if (punch.direction === "in") section creates those
              if (
                previousPunches.length &&
                previousPunches[0].direction === "in"
              ) {
                const punchIn = previousPunches[0];
                if (!isPunchBetweenDateRange(punchIn, startDate, endDate)) {
                  punchTimeline.push(punchIn);
                  punchTimeline.push(punch);
                  hours = (punch.time.seconds - punchIn.time.seconds) / 3600;
                }
              } else {
                punchTimeline.push(punch);
                error = `Missing Punch In`;
              }
            }

            // start building table rows
            if (punchTimeline.length) {
              let mapKey = `${employee.barcodeId}-${punch.jobSite}-${
                punch.direction
              }-${dateFormat(punch.time.seconds)}`;
              if (error) {
                // each rogue punch should get its own row
                mapKey += `-${punch.time.seconds}`;
              }
              // build rows
              if (punchMap[mapKey]) {
                punchMap[mapKey].hours += hours;
                punchMap[mapKey].punchTimeline = punchMap[mapKey].punchTimeline
                  .concat(punchTimeline)
                  .sort(function(a, b) {
                    return (
                      new Date(datetimeFormat(a.time.seconds)) -
                      new Date(datetimeFormat(b.time.seconds))
                    );
                  });
              } else {
                punchMap[mapKey] = {
                  date: dateFormat(punch.time.seconds),
                  barcodeId: employee.barcodeId,
                  employee: employee,
                  punchTimeline: punchTimeline,
                  code: employee.department,
                  rate: rate,
                  jobSiteName: jobSiteName,
                  jobSite: jobSite,
                  hours: hours,
                  error: error,
                  early: "",
                  late: "",
                  source: punch.source,
                  key: mapKey,
                  startDate: employee.startDate,
                  ignoreLunchRule: ignoreLunchRule,
                  jobSiteDepartment: jobSiteDepartment,
                };
              }
            }
          }
        });

        // get active employee schedules
        const activeEmployeeSchedules = [];
        const scheduleRes = await fb.db
          .collection("employeeSchedule")
          .where("lastShiftDate", ">=", moment().format("YYYY-MM-DD"))
          .get();
        scheduleRes.forEach((doc) => {
          const data = doc.data();
          activeEmployeeSchedules.push(data);
        });

        const table = [];
        Object.keys(punchMap).forEach((key) => {
          punchMap[key].hours = hoursRoundv2(
            punchMap[key].hours,
            punchMap[key].punchTimeline
          );

          // Approving a no-lunch claim waives ONE lunch, not the whole shift.
          //
          // This used to set a single skipLunchRule boolean, so one approved claim
          // suppressed the entire deduction: a 12-hour shift where the worker took
          // one lunch and had their "only took one" claim approved gave back the
          // whole hour instead of half of it. All or nothing, as payroll reported.
          //
          // So the automatic rule still decides how many lunches a shift owes, and
          // each approved claim removes one of them.
          const outPunches = punchMap[key].punchTimeline.filter(p => p.direction === 'out');
          const approvedNoLunchCount = outPunches.reduce((count, p) => {
            // lunches is an array normally, but some records hold it as an object
            // keyed "0", "1" from an old Firestore dot-notation write
            let lunches = [];
            if (Array.isArray(p.lunches)) {
              lunches = p.lunches;
            } else if (p.lunches && typeof p.lunches === 'object') {
              lunches = Object.values(p.lunches);
            }

            let approved = lunches.filter(
              l => l && l.notes && l.approvalStatus === 'approved'
            ).length;

            // The single-lunch shape these predate
            if (!lunches.length && p.lunch && p.lunch.taken === false && p.lunch.approvalStatus === 'approved') {
              approved = 1;
            }
            return count + approved;
          }, 0);

          const automaticDeduction = getHoursDeducted(
            punchMap[key].hours,
            punchMap[key].ignoreLunchRule
          );
          // Clamped: more approved claims than the shift owes lunches must not turn
          // a deduction into added hours
          punchMap[key].hoursDeducted = Math.max(
            0,
            automaticDeduction - approvedNoLunchCount * 0.5
          );
          punchMap[key].hours =
            punchMap[key].hours - punchMap[key].hoursDeducted;
          punchMap[key].wages = (
            punchMap[key].rate * punchMap[key].hours
          ).toFixed(2);
          // if missing punch is included in error
          if (!punchMap[key].error) {
            const matchingSchedule = activeEmployeeSchedules.find(
              (schedule) =>
                schedule.jobSite === punchMap[key].jobSite &&
                schedule.employees.includes(punchMap[key].employee.docId)
            );
            const isYard = punchMap[key].jobSiteName.startsWith("Yard Payroll");
            const isAsbestos = punchMap[key].jobSiteDepartment.includes(
              "Asbestos"
            );
            const jobId15 = punchMap[key].jobSiteName.includes("(15");
            if (!matchingSchedule) {
              if (!isYard && !isAsbestos && !jobId15) {
                punchMap[key].ns = "NS";
              }
            } else {
              const { startTime, endTime, daysOfWeek } = matchingSchedule;
              const punchDay = moment(punchMap[key].date, "MM/DD/YYYY").format(
                "dddd"
              );

              if (daysOfWeek.includes(punchDay)) {
                // Convert scheduled times to full timestamps for the same day as the punches
                const punchDate = moment(punchMap[key].date, "MM/DD/YYYY");
                const scheduledStart = punchDate.clone().set({
                  hour: parseInt(startTime.split(":")[0], 10),
                  minute: parseInt(startTime.split(":")[1], 10),
                  second: 0,
                  millisecond: 0,
                });
                const scheduledEnd = punchDate.clone().set({
                  hour: parseInt(endTime.split(":")[0], 10),
                  minute: parseInt(endTime.split(":")[1], 10),
                  second: 0,
                  millisecond: 0,
                });

                // Convert punch-in and punch-out times from Firebase timestamps
                const punchInTime = moment.unix(
                  punchMap[key].punchTimeline[0].time.seconds
                );
                const punchOutTime = moment.unix(
                  punchMap[key].punchTimeline[1].time.seconds
                );

                // Calculate early and late minutes
                const earlyMinutes = scheduledStart.diff(
                  punchInTime,
                  "minutes"
                );
                const lateMinutes = punchOutTime.diff(scheduledEnd, "minutes");

                if (
                  earlyMinutes > 0 &&
                  earlyMinutes >= 8 &&
                  earlyMinutes < 300
                ) {
                  punchMap[key].early = `${earlyMinutes}m early`;
                }
                if (lateMinutes > 0 && lateMinutes >= 8 && lateMinutes < 300) {
                  punchMap[key].late = `${lateMinutes}m late`;
                  // Get late clock-out reason from the OUT punch if available
                  const outPunch = punchMap[key].punchTimeline[1];
                  if (outPunch && outPunch.lateClockOutReason) {
                    punchMap[key].lateClockOutReason = outPunch.lateClockOutReason;
                  }
                }
              }
            }
          }
          table.push(punchMap[key]);
        });

        this.leaderboard = getLeaderboardStats(table);
        this.locationStats = getLocationStats(table);
        this.fullTable = table;

        if (this.filter.department && this.filter.department.length) {
          this.table = table.filter((t) =>
            this.filter.department.includes(t.code)
          );
        } else {
          this.table = table;
        }
        this.loading = false;
      } catch (e) {
        console.log("getTable error", e);
        alert("Error loading data.");
      }
    },
    viewEmployee: function(employee) {
      this.$router.push(`/employees/${employee.docId}`);
    },
    showEmployeeNoteDialog: function(item) {
      this.selectedEmployee = item.employee;

      // Get the punch in date from the first punch record
      const punchInDate =
        item.punchTimeline && item.punchTimeline.length > 0
          ? item.punchTimeline[0].time.toDate()
          : new Date();

      // Format the date for the reference
      const formattedDate = this.$moment(punchInDate).format("MMM Do YYYY");

      // Preload the note field with reference to the punch date
      this.newEmployeeNote = `\n\nRE: punch date ${formattedDate}`;

      this.dialogEmployeeNote = true;

      // Set cursor to beginning of textarea after dialog opens
      this.$nextTick(() => {
        if (this.$refs.employeeNoteTextarea) {
          const textarea = this.$refs.employeeNoteTextarea.$el.querySelector(
            "textarea"
          );
          if (textarea) {
            textarea.focus();
            textarea.setSelectionRange(0, 0);
          }
        }
      });
    },
    cancelEmployeeNote: function() {
      this.selectedEmployee = null;
      this.newEmployeeNote = "";
      this.dialogEmployeeNote = false;
    },
    saveEmployeeNote: async function() {
      if (!this.newEmployeeNote.trim() || !this.selectedEmployee) return;

      try {
        this.savingEmployeeNote = true;

        // Add note to Firebase
        await fb.db.collection("employeeNotes").add({
          employee: this.selectedEmployee.docId,
          note: this.newEmployeeNote.trim(),
          createdBy: this.user.uid,
          createdByName: this.user.name || this.user.email,
          createDate: fb.timestamp,
        });

        // Show success message
        this.snack = true;
        this.snackText = `Note added for ${this.selectedEmployee.firstName} ${this.selectedEmployee.lastName}`;
        this.snackColor = "success";

        // Close dialog and reset
        this.cancelEmployeeNote();
      } catch (error) {
        console.log("saveEmployeeNote error", error);
        this.snack = true;
        this.snackText = "Error adding employee note";
        this.snackColor = "error";
      }

      this.savingEmployeeNote = false;
    },
    getJobSiteLocation: function(jobSiteId) {
      // Find the job site and return its geolocation if available
      const jobSite = this.jobSites.find((j) => j.id === jobSiteId);
      if (jobSite && jobSite.geolocation) {
        return {
          latitude: jobSite.geolocation.latitude,
          longitude: jobSite.geolocation.longitude,
        };
      }
      return null;
    },
    showEmployeeNotesListDialog: async function(employee) {
      try {
        this.selectedEmployee = employee;
        this.loadingEmployeeNotes = true;
        this.dialogEmployeeNotesList = true;
        this.employeeNotes = [];

        // Fetch notes for this employee (without orderBy to avoid index requirement)
        const notesRes = await fb.db
          .collection("employeeNotes")
          .where("employee", "==", employee.docId)
          .get();

        const notes = [];
        notesRes.forEach((doc) => {
          const data = doc.data();
          data.docId = doc.id;
          // Convert Firestore timestamp to Date if it exists
          if (data.createDate && data.createDate.toDate) {
            data.createDate = data.createDate.toDate();
          }
          notes.push(data);
        });

        // Sort notes by createDate descending (newest first) in JavaScript
        notes.sort((a, b) => {
          if (!a.createDate) return 1;
          if (!b.createDate) return -1;
          return new Date(b.createDate) - new Date(a.createDate);
        });

        // Limit to 50 most recent notes
        this.employeeNotes = notes.slice(0, 50);
        this.loadingEmployeeNotes = false;
      } catch (error) {
        this.loadingEmployeeNotes = false;
        this.snack = true;
        this.snackText = "Error loading employee notes";
        this.snackColor = "error";
      }
    },
  },
};
</script>
